// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1SmnR","footer":"ModalCreateQualiphyProcedure_footer__23jv-","additionData":"ModalCreateQualiphyProcedure_additionData__3Y2In"};